import { render, staticRenderFns } from "./CustomTheme.vue?vue&type=template&id=3d10e534&"
import script from "./CustomTheme.vue?vue&type=script&lang=js&"
export * from "./CustomTheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports